import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketOptionalPartsDetailsAC } from './AC/BasketOptionalPartsDetails.AC';
import { BasketOptionalPartsDetailsOV } from './OV/BasketOptionalPartsDetails.OV';
import { BasketOptionalPartsDetailsAP } from './AP/BasketOptionalPartsDetails.AP';
import { BasketOptionalPartsDetailsDS } from './DS/BasketOptionalPartsDetails.DS';
import { BasketOptionalPartsDetailsOV as BasketOptionalPartsDetailsOV_GB } from './OV/GB/BasketOptionalPartsDetails.OV';
import { BasketOptionalPartsStyled } from './BasketOptionalPartsStyled';
import { SC } from '../../../styles/theme';

export type BasketOptionalFeesDetailsProps = SC & {
    showFees?: boolean;
    showAccessories?: boolean;
    generatedIndex?: number;
};

const BasketOptionalPartsDetails = (props: BasketOptionalFeesDetailsProps) => {
    if (BRAND === 'AC') return <BasketOptionalPartsDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <BasketOptionalPartsDetailsOV_GB {...props} />
        ) : (
            <BasketOptionalPartsDetailsOV {...props} />
        );
    if (BRAND === 'AP') return <BasketOptionalPartsDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketOptionalPartsDetailsDS {...props} />;
    return <BasketOptionalPartsStyled {...props} />;
};

export default BasketOptionalPartsDetails;
